import { useEffect } from 'react';
import { createValueStore } from '@sorrem-client/ui/shared/value-store';
import { useValueStoreSelector } from './value-store';

/** How many guided tours (#234) are on screen right now. */
const runningCount = createValueStore(0);

const isAnyRunning = (count: number): boolean => count > 0;

/**
 * Marks a guided tour as on screen while `isRunning` is true and the caller is
 * mounted, so UI that would compete with it (first-time callouts, run hints)
 * waits until it ends.
 */
export function useMarksTourRunning(isRunning: boolean): void {
    useEffect(() => {
        if (!isRunning) {
            return undefined;
        }
        runningCount.set((count) => count + 1);
        return (): void => runningCount.set((count) => count - 1);
    }, [isRunning]);
}

/** Whether a guided tour is on screen (see `useMarksTourRunning`). */
export function useIsTourRunning(): boolean {
    return useValueStoreSelector(runningCount, isAnyRunning);
}
